import './index.css';
import reportWebVitals from './reportWebVitals';
import { bootstrapApp } from './bootstrapApp';
import { APP_NAME } from './config/brandingConfig';

bootstrapApp().catch((error) => {
  console.error('[bootstrap] Application failed to start', error);
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;font-family:system-ui,sans-serif;background:#fff;color:#0f172a;text-align:center;">
        <div>
          <h1 style="font-size:1.25rem;margin:0 0 8px;">Unable to start ${APP_NAME || 'LHRC ERP'}</h1>
          <p style="margin:0;color:#475569;">Please refresh the page. If the problem continues, contact support.</p>
        </div>
      </div>
    `;
  }
});

reportWebVitals();
